import { Col } from 'antd';
import IntroBlock from 'components/public/Intro/IntroBlock';
import { InterestState } from 'components/SubscribeForm/utils';
import React from 'react';
import findMatchingUseCases from './utils/findMatchingUseCases';

import UseCases from '../UseCases';
import OnboardingFlow from '../OnboardingFlow';
import { useIntl } from 'react-intl';

export type HitchNextStepsProps = {
  interestState: InterestState;
};

const HitchNextSteps = ({ interestState }: HitchNextStepsProps): JSX.Element => {
  const { firstApp, secondApp, hitchId } = interestState;
  const { formatMessage } = useIntl();

  const usecases = findMatchingUseCases({ firstApp, secondApp });

  if (!firstApp) {
    return <></>;
  }

  if (!secondApp) {
    return (
      <IntroBlock
        type="white"
        title={formatMessage({
          defaultMessage: "What's possible?",
          description: 'nextsteps/one-app/title',
        })}
        subTitle={formatMessage(
          {
            defaultMessage: `Check what you can do when hitching {app}`,
            description: 'nextsteps/one-app/description',
          },
          { app: interestState.oneAppSelectedAppName }
        )}
        description={
          <Col>
            <UseCases usecases={usecases} />
          </Col>
        }
      />
    );
  }

  if (firstApp.status !== 'supported' || secondApp?.status !== 'supported') {
    return (
      <IntroBlock
        type="white"
        title={formatMessage({
          defaultMessage: 'How can we help?',
          description: 'nextsteps/one-supported-app/title',
        })}
        subTitle={formatMessage({
          defaultMessage: 'What is possible?',
          description: 'nextsteps/one-supported-app/subtitle',
        })}
        description={
          <Col>
            <UseCases usecases={usecases} />
          </Col>
        }
      />
    );
  }

  return hitchId ? <OnboardingFlow usecases={usecases} hitchId={hitchId} /> : <></>;
};

export default HitchNextSteps;
